import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import xlsx from 'json-as-xlsx';

import downloadSvg from 'assets/icons/download.svg';
import Button, { Color, Size } from 'lib/Button';
import { getMarketId } from 'store/publisher/selectors';
import { getV2AssetTemplate } from './getV2AssetTemplate';

const getDownloadFileName = (marketId: string): string => `${marketId}_DL_TEMPLATE_V2`;

const DownloadV2AssetTemplate = (): React.ReactElement => {
  const marketId = useSelector(getMarketId);
  const handleDownloadTemplate = useCallback((): void => {
    xlsx(getV2AssetTemplate(), {
      fileName: getDownloadFileName(marketId),
    });
  }, [marketId]);

  return (
    <Button
      onClick={handleDownloadTemplate}
      color={Color.SECONDARY}
      size={Size.LARGE}
      svg={downloadSvg}
      label="Download template"
    />
  );
};

export default DownloadV2AssetTemplate;
